module.exports = __webpack_public_path__ + "static/img/thstart.d472b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thstart.png
// module id = co3R
// module chunks = 1